<template>
  <div class="navbar">
    <div class="topTitle w-100 flex_row_c">
      <div class="titleText pointer" @click="$router.push('/screen/homePage')">
        能源e+资源聚合平台
      </div>
    </div>
    <!-- 左侧菜单 -->
    <!-- <div class="left_menu absolute flex_row_r z-100">
      <div
        v-for="(item, index) in leftMenu"
        :key="index"
        class="menu_item pointer flex_row_c"
        :class="{ activeRoute: $route.path.includes(item.path) }"
        @click="routeTo(item.path)"
      >
        {{ item.menuName }}
      </div>
    </div> -->
    <!-- 右侧菜单 -->
    <!-- <div class="right_menu absolute flex_row_l z-100">
      <div
        v-for="(item, index) in rightMenu"
        :key="index"
        class="menu_item pointer flex_row_c"
        :class="{ activeRoute: $route.path.includes(item.path) }"
        @click="routeTo(item.path)"
      >
        {{ item.menuName }}
      </div>
    </div> -->
    <!-- 操作栏 -->
    <div class="action_bar absolute flex_row_r">
      <div class="weather flex_row_c margin-right-20">
        <img
          style="width: 1.4rem; margin: 0 0.2rem 0.1rem 0"
          src="@/assets/screen/weather.png"
        />
        <span class="font-size-12">今日多云</span>
      </div>
      <div class="currentTime font-size-12">{{ currentTime }}</div>
    </div>

    <div
      class="pointer font-family-din font-weight-bold"
      style="
        position: fixed;
        right: 0;
        top: 0rem;
        z-index: 999;
        width: 3rem;
        height: 2rem;
      "
      @click="$router.push('/file-management/subsystem-file')"
    ></div>
  </div>
</template>

<script>
import { UserUtil } from '@/utils/user-utils';
import { DateUtil } from '@/utils/date-util';
import { mapGetters } from 'vuex';
import Screenfull from '@/components/Screenfull';
import ThemeSelect from '@/components/ThemeSelect';
import LanguageChange from '@/components/LanguageChange';
import axios from 'axios';
import WeatherItem from './WeatherItem.vue';
import { leftMenu, rightMenu } from '../menuList';

export default {
  components: {
    Screenfull,
    LanguageChange,
    WeatherItem,
    ThemeSelect,
  },
  data() {
    return {
      objCount: {},
      forbidNum: '',
      visible: false,
      leftMenu: leftMenu,
      rightMenu: rightMenu,
      activeIndex: 0,
      activePath: this.$route.path,
      currentTime: '',
    };
  },
  computed: {
    ...mapGetters(['sidebar']),
  },
  mounted() {
    sessionStorage.setItem('activePath', this.$route.path);
    this.currentTime = DateUtil.getDateTimeSecond(new Date());
    setInterval(() => {
      this.currentTime = DateUtil.getDateTimeSecond(new Date());
    }, 1000);
  },
  methods: {
    handleClick(show) {
      this.visible = show;
    },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
    },
    handleLogout() {
      this.$confirm('确定注销并退出系统吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          // this.handleDeleteToken();
          // UserUtil.logout();
          this.$router.push('/');
          // this.$store.dispatch('tagsView/delAllViews', '');
        })
        .catch(() => {});
    },
    handleDeleteToken() {
      axios
        .delete(process.env.VUE_APP_SERVER_PERMISSION + '/logout', {
          headers: {
            Authorization: UserUtil.getToken(),
          },
        })
        .then((res) => {});
    },
    handleWarn() {
      if (this.$route.path.includes('/offline-list')) return;
      this.$router.push('/event-record/offline-list');
    },
    jumpScreen() {
      window.open('http://192.168.0.130:8888/las/#/');
      // window.open('http://10.10.0.112:31626/las/#/');
    },
    routeTo(path) {
      if (this.$route.path == path) {
        return;
      } else {
        this.$router.push(path);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/css-theme/handle.scss';
@import '~@/styles/variables.scss';

.navbar {
  height: 100%;
  position: relative;
  // @include background_color('navbar_bg_color');
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  color: #fff;
  .left_menu {
    width: 31%;
    left: 0;
    top: 0.8rem;
    .menu_item {
      margin-left: 2rem;
      background: url('@/assets/screen/leftmenuList.png');
      background-size: 100% 100%;
    }
    .activeRoute {
      background: url('@/assets/screen/leftmenuListBright.png');
      background-size: 100% 100%;
      color: #fff;
      animation: topTitleShine 1s infinite;
    }
    @keyframes topTitleShine {
      0%,
      100% {
        // color: #00eaff;
        text-shadow: 2px 2px 10px #00eaff, 2px 2px 10px #00eaff;
      }
      50% {
        text-shadow: 2px 2px 10px #00eaff, 2px 2px 3rem #00eaff;
      }
    }
  }
  .right_menu {
    width: 31%;
    right: 0;
    top: 0.8rem;
    .menu_item {
      margin-right: 2rem;
      background: url('@/assets/screen/rightmenuList.png');
      background-size: 100% 100%;
    }
    .activeRoute {
      background: url('@/assets/screen/rightmenuListBright.png');
      background-size: 100% 100%;
      color: #fff;
    }
  }

  .menu_item {
    font-family: 'ysxht';
    width: 8rem;
    height: 2.4rem;
    padding-bottom: 0.5rem;
    color: #d4e5fb;
    letter-spacing: 2px;
  }
}
.action_bar {
  width: 50%;
  top: 0.75rem;
  right: 1.5rem;
  .currentTime {
    font-family: '微软雅黑';
  }
}
.nav-btn-error {
  height: 1.3rem;
  width: 1.3rem;
  line-height: 1.3rem;
  color: #fff;
  cursor: pointer;
}
.topTitle {
  align-items: flex-start;
  height: 100%;
  background: url('@/assets/screen/title.png');
  letter-spacing: 2px;
  background-size: 100% 100%;
  font-family: 'ysbth';
  font-size: 2rem;
  padding-top: 0.2rem;
  color: #fff;
  .titleText {
    background: linear-gradient(180deg, #ffffff, #adccff);
    box-shadow: 0px 6px 2px 0px rgba(0, 0, 0, 0.16);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .backHomePage {
    position: absolute;
    left: 66.6%;
    bottom: 0.4rem;
    font-size: 1rem;
    padding-left: 4rem;
    font-family: 'ysbth';
    cursor: pointer;
    align-items: flex-end;
  }
  .switchViews {
    position: absolute;
    right: 7%;
    bottom: 0.4rem;
    font-size: 1.2rem;
    padding-left: 4rem;
    font-family: 'ysbth';
    cursor: pointer;
  }
  .backScreen {
    position: absolute;
    right: 1%;
    bottom: 0.4rem;
    font-size: 1.2rem;
    font-family: 'ysbth';
    cursor: pointer;
  }
}
::v-deep .el-badge__content {
  border: 0;
  font-size: 0.5rem;
  height: 1.3rem;
  line-height: 1.3rem;
}
.adminBox {
  width: auto;
  height: 40px;
  padding: 0 10px;
  color: #fff;
  font-size: 0.75rem;
}
</style>
